import { aawzDate } from '@utils/dates/aawz-date'

// Fonte ÚNICA de verdade para "essa proposta expirou pelo relógio do
// cliente" (VERIFY-3h, G-D23 do design-conformance it.3). O backend NUNCA
// empurra um evento avisando que uma proposta venceu — ele só rejeita a
// DECISÃO com 409 "Proposta expirada" quando o clique chega depois do
// prazo (contracts/api.yaml, `/runs/{id_run}/propostas/{id_proposta}/
// decisao`). Por isso o campo bruto `estado` do mapa `propostasAbertas`
// pode continuar `'aberta'` bem depois do `expira_em` já ter passado — quem
// decide "expirou" é sempre o relógio local, nunca o servidor.
export function propostaExpirouPorRelogio(proposta) {
  const expiraEm = proposta && proposta.expira_em
  if (!expiraEm) return false
  const diff = aawzDate(expiraEm).diff(aawzDate())
  if (Number.isNaN(diff)) return false
  return diff <= 0
}

// "Está genuinamente aberta" = servidor ainda não decidiu (`estado ===
// 'aberta'`) E o relógio local não já expirou o prazo. Antes do VERIFY-3h,
// `view-chat-modo-agente.mixin.js::quantidadePropostasAbertas` só checava a
// primeira metade (campo bruto), e `ia-confirm-action.vue::estadoVisual`
// só a segunda (via seu próprio `expirouPorRelogio` local) — o card já
// mostrava "Proposta expirada." mas o contador do chip continuava contando
// a MESMA proposta como aberta (duas fontes de verdade divergentes para o
// mesmo fato, "Uma fonte de verdade" no CLAUDE.md raiz). Os dois lugares
// agora chamam esta função.
export function propostaEstaAberta(proposta) {
  if (!proposta || proposta.estado !== 'aberta') return false
  // [T313] O `estado` bruto pode dizer 'aberta' depois de o RUN ter
  // terminado: é literalmente o que o banco guarda para a proposta que
  // ninguém decidiu a tempo, e o relatório do run (`propostas` de
  // `run-atual`) a devolve assim, com `resultado='expirada'` sintetizado.
  // `decisao.py` recusa qualquer decisão de run encerrado (`run_ja_encerrado`)
  // ANTES de olhar a proposta — desenhar "Aprovar" aqui daria um botão que só
  // sabe responder 409. Desfecho do servidor fecha a proposta, venha ele do
  // `estado` ou do `resultado`.
  if (proposta.resultado) return false
  return !propostaExpirouPorRelogio(proposta)
}
